import { Link } from '@tanstack/react-router'
import { CornerUpRightIcon, FileUpIcon, MessageSquarePlusIcon, PlusIcon } from 'lucide-react'
import { PropsWithChildren, useMemo } from 'react'

import { Button } from '../ui/button'

type Props = {
  body: string
  ctaLink?: string
  ctaText?: string
  ctaType?: 'navigate' | 'create-content' | 'other' | 'upload-file' | 'new-chat'
  heading: string
  onClickCta?(): void
}

const EmptyState = ({
  body,
  children,
  ctaLink,
  ctaText,
  ctaType = 'other',
  heading,
  onClickCta,
}: PropsWithChildren<Props>) => {
  const ctaIcon = useMemo(() => {
    switch (ctaType) {
      case 'navigate':
        return <CornerUpRightIcon />
      case 'create-content':
        return <PlusIcon />
      case 'upload-file':
        return <FileUpIcon />
      case 'new-chat':
        return <MessageSquarePlusIcon />
      default:
        return null
    }
  }, [ctaType])

  return (
    <div className="gap-6 flex flex-col items-center p-20 card">
      <div className="gap-1.5 flex flex-col">
        <h4 className="text-xl font-semibold text-center">{heading}</h4>
        <p className="text-text-secondary text-center">{body}</p>
      </div>
      {(onClickCta || ctaLink) && (
        <Link to={ctaLink || '#'}>
          <Button onClick={onClickCta} size="lg">
            {ctaIcon}
            {ctaText}
          </Button>
        </Link>
      )}
      {children}
    </div>
  )
}

export { EmptyState }
